import { Box, Button, Modal, TextInput, toast } from '@palmetto/palmetto-components';
import { FormikValues, useFormik } from 'formik';
import { SyntheticEvent } from 'react';
import * as yup from 'yup';

import { useEditHoldbackMutation } from '../../../services/pricing';

export const EditHoldbackModal = ({
  isModalOpen,
  closeModal,
  holdbackId,
  holdbackName,
}: {
  isModalOpen: boolean;
  closeModal: (event?: SyntheticEvent) => void;
  holdbackId: string;
  holdbackName: string;
}) => {
  const [editHoldback] = useEditHoldbackMutation();

  const formik = useFormik({
    initialValues: {
      name: holdbackName,
    },
    validationSchema: yup.object({
      name: yup.string().required('Option Name is required'),
    }),
    enableReinitialize: true,
    onSubmit: async (values: FormikValues, { setSubmitting }) => {
      try {
        await editHoldback({
          id: holdbackId,
          data: { name: values.name },
        }).unwrap();
        toast.success('Holdback updated successfully');
        closeModal();
      } catch (e) {
        console.error(e);
        toast.error('Error updating holdback');
      } finally {
        setSubmitting(false);
      }
    },
  });
  return (
    <Modal ariaLabelledBy="editHoldback" isOpen={isModalOpen} onDismiss={closeModal} maxWidth="500px">
      <Modal.Header id="editHoldback" title="Edit Holdback Name" onDismiss={closeModal} />
      <form onSubmit={formik.handleSubmit}>
        <Modal.Body background="secondary">
          <Box direction="column" childGap="md">
            <TextInput
              type="text"
              label="Option Name"
              name="name"
              id="name"
              value={formik.values.name}
              onChange={(event) => formik.setFieldValue('name', event.target.value)}
              isRequired
              onBlur={formik.handleBlur}
              error={formik.touched.name && (formik.errors.name as string)}
            />
          </Box>
        </Modal.Body>
        <Modal.Footer>
          <Button
            as="button"
            onClick={() => {
              formik.resetForm();
              closeModal();
            }}
            variant="secondary"
            tone="neutral"
            size="md"
            isLoading={formik.isSubmitting}
          >
            Cancel
          </Button>
          <Button variant="primary" size="md" type="submit" isLoading={formik.isSubmitting}>
            Save
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
};
